const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
  errors?: any;
}

class ApiService {
  private async request<T>(endpoint: string, options?: RequestInit): Promise<ApiResponse<T>> {
    const url = `${API_BASE_URL}${endpoint}`;
    
    const config: RequestInit = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      ...options,
    };

    const response = await fetch(url, config);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return response.json();
  }

  // Banner APIs
  async getBanners() {
    return this.request('/banners');
  }

  // Service APIs
  async getServices() {
    return this.request('/services');
  }

  // Work APIs
  async getWorks(params?: { category?: string; featured?: boolean }) {
    const queryParams = new URLSearchParams();
    if (params?.category) queryParams.append('category', params.category);
    if (params?.featured) queryParams.append('featured', 'true');
    
    const endpoint = `/works${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return this.request(endpoint);
  }

  async getWork(id: number) {
    return this.request(`/works/${id}`);
  }

  // Contact Form API
  async submitContact(data: {
    name: string;
    email: string;
    phone: string;
    subject?: string;
    message: string;
  }) {
    return this.request('/contact', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // Booking Form API
  async submitBooking(data: {
    name: string;
    email: string;
    phone: string;
    service: string;
    preferred_date: string;
    preferred_time: string;
    message?: string;
  }) {
    return this.request('/bookings', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}

export default new ApiService();